import { render, staticRenderFns } from "./QuotationPriceHistoryDelete.vue?vue&type=template&id=6c8f5dc4&"
import script from "./QuotationPriceHistoryDelete.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports